module.exports = __webpack_public_path__ + "img/1464617093.b65ae9bb.jpg";